import axios from 'axios'
import { apiClientStore } from './stores'
import { config } from './configs/config'

const API_URL = config.api.url

class ApiClient {
  client = axios.create()

  constructor() {
    this.client.defaults.headers.common.Authorization = `Basic ${btoa(`:${this.getAppToken()}`)}`
    this.initInterceptors()
  }

  initInterceptors() {
    this.client.interceptors.request.use(
      request => {
        apiClientStore.showLoader(true)

        return request
      },
      error => {
        apiClientStore.showAlert({ type: 'danger', message: error.message })
        apiClientStore.showLoader(false)

        return Promise.reject(error)
      }
    )

    this.client.interceptors.response.use(
      response => {
        apiClientStore.showLoader(false)
        if (response?.data?.errors?.length > 0) {
          const error = response.data.errors[0].message
          let errorMessage = 'Something went wrong. Please reload the page'
          apiClientStore.showAlert({ type: 'danger', message: errorMessage })

          return Promise.reject(error)
        }

        return response
      },
      error => {
        apiClientStore.showAlert({ type: 'danger', message: error.message })
        apiClientStore.showLoader(false)

        return Promise.reject(error)
      }
    )
  }

  async get(url: string): Promise<any> {
    return (await this.client.get(`${API_URL}${url}`))?.data
  }

  async post(url: string, body: any): Promise<any> {
    return (await this.client.post(`${API_URL}${url}`, body))?.data
  }

  async put<T= any>(url: string, body: Partial<T>): Promise<T> {
    return (await this.client.put(`${API_URL}${url}`, body))?.data
  }

  async delete(url: string): Promise<any> {
    return (await this.client.delete(`${API_URL}${url}`))?.data
  }

  async postGql(url: string, body: any): Promise<any> {
    let config = { headers: { 'Content-Type': 'application/json' } }

    return (await this.client.post(`${API_URL}${url}`, JSON.stringify(body), config))?.data?.data
  }

  private getAppToken = () => new URLSearchParams(window.location.search).get('token')

}

export const apiClient = new ApiClient()
